module.exports = __webpack_public_path__ + "static/img/industries13.2351ee0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industries13.png
// module id = osoi
// module chunks = 1